var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetaparabaixo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4293_15765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3752 6.17578L8.20636 10.3443C8.17929 10.3714 8.14717 10.3929 8.11182 10.4075C8.07643 10.4222 8.03851 10.4298 8.00024 10.4298C7.96198 10.4298 7.92406 10.4222 7.88867 10.4075C7.85332 10.3929 7.8212 10.3714 7.79413 10.3443L3.62524 6.17578",
    stroke: "#6B7284",
    strokeWidth: 0.583333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4293_15765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33333,
    height: 9.33333,
    fill: "white",
    transform: "translate(3.33325 3.33325)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaparabaixo);
export default __webpack_public_path__ + "static/media/setaparabaixo.301dd44b7558e5aa8e803ca071feaf1d.svg";
export { ForwardRef as ReactComponent };